export const LOAD = '@@init/LOAD';
export const PARSE_URL = '@@init/PARSE_URL';
